import gatewayApi from "./gatewayAxios";

export const fetchWalletBalanceApi = async (username, accountNo, token) => {
  const headers = {
    "X-Channel": "WEB",
    Authorization: token ? `Bearer ${token}` : undefined,
  };

  const url = `/business/wallet/balance/v1?mid=${username}&account_no=${accountNo}`;

  const response = await gatewayApi.get(url, { headers });
  return response.data;
};

export const fetchAepsBalanceApi = async (username, accountNo, token) => {
  const headers = {
    "X-Channel": "WEB",
    Authorization: token ? `Bearer ${token}` : undefined,
  };

  const url = `/business/wallet/view/aeps_wallet/balance?mid=${username}&account_no=${accountNo}`;

  const response = await gatewayApi.get(url, { headers });
  return response.data;
};

// Fixed function name and parameter handling
export const fetchLienBalanceApi = async (username, token) => {
  const headers = {
    "X-Channel": "WEB",
    Authorization: token ? `Bearer ${token}` : undefined,
  };

  const url = `/dmt/wallet/get/lien-amount?mid=${username}`;

  try {
    const response = await gatewayApi.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error("Lien balance API error:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchSettlementBalanceApi = async (username, accountNo, token) => {
  const headers = {
    "X-Channel": "WEB",
    Authorization: token ? `Bearer ${token}` : undefined,
  };

  const url = `/business/wallet/view/settle/balance?mid=${username}&account_no=${accountNo}`;

  try {
    const response = await gatewayApi.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error(
      "Settlement balance API error:",
      error.response?.data || error.message
    );
    throw error;
  }
};
